/**
 * Iter 203.3 — Cliente API de Drops (público + admin).
 * El backend es la única autoridad: el frontend solo pregunta, reporta
 * rendered/catch/miss y envía métricas de polling. Nunca acredita premios.
 */
import { api } from '@/lib/api';

export const dropsApi = {
  next(contextType, contextId) {
    const params = new URLSearchParams({
      context_type: contextType, context_id: contextId,
    });
    return api.get(`/drops/next?${params.toString()}`);
  },
  catch(dropEventId) { return api.post(`/drops/${dropEventId}/catch`); },
  miss(dropEventId) { return api.post(`/drops/${dropEventId}/miss`); },
  rendered(dropEventId) { return api.post(`/drops/${dropEventId}/rendered`); },
  metrics(body) { return api.post('/drops/metrics', body); },
};

export const adminDropsApi = {
  list() { return api.get('/admin/drops/campaigns'); },
  create(body) { return api.post('/admin/drops/campaigns', body); },
  update(id, body) { return api.patch(`/admin/drops/campaigns/${id}`, body); },
  setStatus(id, action) {
    return api.post(`/admin/drops/campaigns/${id}/status`, { action });
  },
  stats(id) { return api.get(`/admin/drops/campaigns/${id}/stats`); },
  metricsOverview() { return api.get('/admin/drops/metrics/overview'); },
};
